// Top navigation bar for the super-admin app — indigo accent per design spec.
//
// Section navigation (Tenants/Templates/Users/Audit Logs) lives on the left;
// account-personal surfaces (Security, Sign out) live in UserMenu on the
// right. Adding new Settings sub-pages goes through UserMenu so the top bar
// doesn't grow as the product does.

import type { JSX } from "react";
import { NavLink } from "react-router-dom";
import { UserMenu } from "./UserMenu.js";

const NAV_LINKS = [
  { to: "/",           label: "Tenants" },
  { to: "/templates",  label: "Templates" },
  { to: "/users",      label: "Users" },
  { to: "/audit-logs", label: "Audit Logs" },
];

export function AdminNav(): JSX.Element {
  return (
    <header className="bg-indigo-700 text-white shadow-md">
      <div className="max-w-5xl mx-auto px-4 flex items-center justify-between h-14">
        <div className="flex items-center gap-6">
          <span className="text-lg font-bold tracking-tight">HCM Admin</span>
          <nav className="flex gap-1">
            {NAV_LINKS.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-indigo-900 text-white"
                      : "text-indigo-200 hover:bg-indigo-600 hover:text-white"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
        <UserMenu />
      </div>
    </header>
  );
}
